import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Track } from '@app/core/models/Track';
import { PlayAudio, Resume, Stop } from '@app/core/states/audio.actions';
import { AudioState } from '@app/core/states/audio.state';
import { TrackDetails } from '@app/library/states/editing-track.actions';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-track-mobile-line',
  templateUrl: './track-mobile-line.component.html',
  styleUrls: ['./track-mobile-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackMobileLineComponent<T extends Track = Track> {
  @Input()
  track: T;

  @Select(AudioState.currentTrackPlaying)
  currentTrackPlaying$: Observable<Track>;

  @Select(AudioState.isPlaying)
  isPlaying$: Observable<boolean>;

  constructor(private readonly store: Store) {}

  @Dispatch()
  playTrack(track: Track) {
    const currentTrackPlaying = this.store.selectSnapshot(AudioState.currentTrackPlaying);
    const isPlaying = this.store.selectSnapshot(AudioState.isPlaying);
    if (currentTrackPlaying?.id === track.id) {
      if (isPlaying) {
        return new Stop();
      } else {
        return new Resume();
      }
    }

    return new PlayAudio(track);
  }

  trackPlaying(track: Track, currentTrack: Track, isPlaying: boolean) {
    return currentTrack?.id === track?.id && isPlaying;
  }

  @Dispatch()
  openTrackDetails(track: T) {
    return new TrackDetails(track);
  }
}
